import React from 'react';
import PropTypes from 'prop-types';
import {
    LOGIN_STATE_LABELS,
    LOGIN_STATE_STYLES,
    LOGIN_STATE_TITLES,
    LOGIN_STATE_UNKNOWN_LABEL
} from '../global/clientUserLogin';

/**
 * Describe a keycloak_status value for display.
 *
 * @param {string|undefined} status
 * @return {{label: string, title: string, style: Object|undefined}}
 */
export const describeLoginState = (status) => {
    const known = Object.prototype.hasOwnProperty.call(LOGIN_STATE_LABELS, status);
    return {
        label: (known) ? LOGIN_STATE_LABELS[status] : LOGIN_STATE_UNKNOWN_LABEL,
        title: (known) ? LOGIN_STATE_TITLES[status] : LOGIN_STATE_TITLES.unknown,
        style: (known) ? LOGIN_STATE_STYLES[status] : LOGIN_STATE_STYLES.unknown
    };
};

/**
 * A Client User's login state as Keycloak reports it (#265), for the list,
 * Show and Edit views. Reads keycloak_status from the record.
 *
 * @param {Object} record
 * @param {string} source
 * @return {JSX.Element}
 */
const ClientUserLoginField = ({record, source}) => {
    const state = describeLoginState((record) ? record[source] : undefined);
    return (
        <span className="client-user-login-state" style={state.style} title={state.title}>
            {state.label}
        </span>
    );
};

ClientUserLoginField.propTypes = {
    record: PropTypes.object,
    source: PropTypes.string,
    label: PropTypes.string,
    addLabel: PropTypes.bool
};

// Labelled like a react-admin field inside SimpleShowLayout
ClientUserLoginField.defaultProps = {
    source: 'keycloak_status',
    label: 'Login',
    addLabel: true
};

export default ClientUserLoginField;
